const defaultDuration = "0";

export default defaultDuration;
